<div class="container">
  <div class="row">
    <div class="col-md-12">
      <h1 id="title" class="title">Login</h1>

      <img [src]="logo" class="login-logo"/>
      <p class="sub-title">Bienvenido a {{appName}}</p>

      <form aria-labelledby="title" class="loader">
        <div class="form-group row">
          <label class="label col-md-12" for="input-email">Usuario:</label>

          <div class="col-md-10">
            <input nbInput fullWidth [(ngModel)]="user.username" name="username" id="input-email" pattern=".+@.+\..+"
                   placeholder="Usuario" fieldSize="large" autofocus (focusout)="validateUser()" (keyup.enter)="validateUser()">
          </div>
          <div class="col-md-2">
            <button nbButton status="danger" (click)="validateUser()"><nb-icon icon="search"></nb-icon></button>
          </div>
        </div>

        <div class="form-control-group">
          <span class="label-with-link">
            <label class="label" for="input-password">Contraseña:</label>
          </span>
          <input #password nbInput fullWidth [(ngModel)]="user.password" name="password" type="password" id="input-password"
                 placeholder="Contraseña" fieldSize="large" [disabled]="!enabledControl">

        </div>

        <div class="form-control-group">
          <span class="label-with-link">
            <label class="label" for="input-password">Sucursal:</label>
          </span>
          <nb-select placeholder="Sucursal" fullWidth [(ngModel)]="user.siteId" name="site" [disabled]="!enabledControl">
            <nb-option *ngFor="let item of siteList" [value]="item.id">{{item.name}}</nb-option>
          </nb-select>
        </div>

        <button nbButton fullWidth status="primary" size="large" [class.btn-pulse]="submitted" [disabled]="!enabledControl" (click)="login()">
          Entrar
        </button> &nbsp;
      </form>
      <div id="loader-wrapper" *ngIf="loading">
        <div id="loader"></div>
      </div>
    </div>
  </div>
</div>
